import React from 'react';
import type { RouteObject } from 'react-router-dom';
import RecipeDashboard from './RecipeDashboard';
import RecipeDetail from './RecipeDetail';
import RecipeForm from './RecipeForm';
import RecipeSOPView from './RecipeSOPView';
import RecipeImport from './RecipeImport';

export const recipeRoutes: RouteObject[] = [
  { path: 'recipes',              element: <RecipeDashboard /> },
  { path: 'recipes/new',          element: <RecipeForm /> },
  { path: 'recipes/import',       element: <RecipeImport /> },
  { path: 'recipes/:id',          element: <RecipeDetail /> },
  { path: 'recipes/:id/edit',     element: <RecipeForm /> },
  { path: 'recipes/:id/sop',      element: <RecipeSOPView /> },
];
